import React from "react";
import { useNavigate } from "react-router-dom";

const Brand = ({ brand }) => {
  const { brand_name, brand_image, brand_slug } = brand;
  const navigate = useNavigate();

  const handleViewBrandProducts = () => {
    navigate(`/brandProducts/${brand_slug}`);
  };

  return (
    <div className="card card-compact lg:w-96 bg-base-100 shadow-xl">
      <figure>
        <img src={brand_image} alt="Shoes" style={{ height: "250px" }} />
      </figure>
      <div className="card-body">
        <h2 className="card-title text-primary">{brand_name}</h2>
        <div className="card-actions justify-end">
          <button className="btn btn-primary" onClick={handleViewBrandProducts}>
            View Gas
          </button>
        </div>
      </div>
    </div>
  );
};

export default Brand;
